import { DSText } from '@zoe/ds-web'
import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react'

interface BannerContent {
  text: ReactNode
  enabled: boolean
}

interface BannerContextProps {
  bannerContent: BannerContent | null
}

const BannerContext = createContext<BannerContextProps | undefined>(undefined)

interface BannerProviderProps {
  children: React.ReactNode
}

export const BannerProvider: React.FC<BannerProviderProps> = ({ children }) => {
  const [bannerContent, setBannerContent] = useState<BannerContent | null>(null)

  useEffect(() => {
    const fetchBannerContent = async () => {
      // const content = await getBannerContent()
      setBannerContent({
        enabled: true,
        text: (
          <DSText variant="fluid-paragraph-200" color="primary-inverse" align="center">
            Get your <span>FREE gift</span> with a Daily30+ 4-month subscription
          </DSText>
        ),
      })
    }
    fetchBannerContent()
  }, [])

  return <BannerContext.Provider value={{ bannerContent }}>{children}</BannerContext.Provider>
}

export const useBanner = () => {
  const context = useContext(BannerContext)
  if (context === undefined) {
    throw new Error('useBanner must be used within a BannerProvider')
  }
  return context
}
